import axios from "axios";
const instance = axios.create({
  baseURL: "https://rigi.ge/laravel/ecom/api"
});
instance.defaults.headers.common["Content-Type"] = "multipart/form-data";
export default instance;
